import makeUseStyles from "@assets/style/util/makeUseStyles"

interface Props {
  children: React.ReactNode
}

export default function MemberReportStatisticCards({ children }: Props) {
  const classes = useStyles()
  return <div className={classes.cards}>{children}</div>
}

export function MemberReportStatisticCardsSkeleton({ children }: Props) {
  const classes = useStyles()

  return <div className={classes.cards}>{children}</div>
}

const useStyles = makeUseStyles((theme) => ({
  cards: {
    display: "flex",
    gap: theme.spacing(2),
    justifyContent: "space-between",
    alignItems: "center",

    [theme.breakpoints.down("md")]: {
      display: "grid",
      gridTemplateColumns: "2fr 2fr",
    },

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
}))
